import type {FC} from 'react';
import React from 'react';
import styles from './cropping-presets.module.scss';
import {CroppingPresetItem} from '../cropping-preset-item';

interface CroppingPresetsProps {
  activePreset: number;
  onPresetSelected: Function;
  imageOriginalRatio: number;
}

export const CroppingPresets: FC<CroppingPresetsProps> = (props) => {
  const onPresetSelected = (val: number) => {
    props.onPresetSelected(val);
  };

  return (
    <>
      <CroppingPresetItem
        className={styles.croppingPresetItem}
        onSelected={onPresetSelected}
        label={window.i18next.t('pmwjs_square')}
        isActive={props.activePreset === 1}
        val={1}
        icon="icon-square"
      />
      <CroppingPresetItem
        className={styles.croppingPresetItem}
        onSelected={onPresetSelected}
        label={window.i18next.t('pmwjs_4_3')}
        isActive={props.activePreset === 1.33}
        val={1.33}
        icon="icon-rectangle"
      />
      {props.imageOriginalRatio !== undefined && (
        <CroppingPresetItem
          className={styles.croppingPresetItem}
          onSelected={onPresetSelected}
          label={window.i18next.t('pmwjs_original')}
          isActive={props.activePreset === props.imageOriginalRatio}
          val={props.imageOriginalRatio}
          icon="icon-resize"
        />
      )}
      <CroppingPresetItem
        className={styles.croppingPresetItem}
        onSelected={onPresetSelected}
        label={window.i18next.t('pmwjs_free')}
        isActive={isNaN(props.activePreset)}
        val={NaN}
        icon="icon-square"
      />
    </>
  );
};
